import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';
import { exportToExcel } from 'src/app/utils/utils.common';


@Injectable({
  providedIn: "root",
})
export class StatisticsService {
  constructor(private http: HttpClient) {}
  get(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http
      .get(urls.API_URL + urls.STATISTICS, { params })
      .pipe(catchError(errorHandl));
  }
  multiSheet(kpiData: any, dateRange: any, tab: any) {
    if (kpiData && dateRange) {
      const formattedStart = moment(dateRange.startDate).format("MM_DD_YYYY");
      const formattedEnd = moment(dateRange.endDate).format("MM_DD_YYYY");

      const fileName = `statistics_${formattedStart}_To_${formattedEnd}.xlsx`;

      const formatAmount = (value: any) => Number(value || 0).toFixed(2);
      const table1 = [
        [
          "Date Range",
          `${moment(dateRange.startDate).format("MM/DD/YYYY")} - ${moment(dateRange.endDate).format("MM/DD/YYYY")}`,
        ],
        [
          "Total Trips",
          "Scheduled Trips",
          "Offered Trips",
          "Reroute Trips",
          "Onway Trips",
          "Arrived Trips",
          "In Progress Trips",
          "Cancelled Trips",
          "Completed Trips",
          "Flat Company",
          "Effective Company",
          "Actual Company",
        ],
        [
          kpiData.totalTrips || 0,
          kpiData.totalScheduled || 0,
          kpiData.totalOffered || 0,
          kpiData.totalReroute || 0,
          kpiData.totalOnway || 0,
          kpiData.totalArrived || 0,
          kpiData.totalInprogress || 0,
          kpiData.totalCancelled || 0,
          kpiData.totalCompleted || 0,

          formatAmount(kpiData.flatCompanyTotal),
          formatAmount(kpiData.effectiveCompanyTotal),
          formatAmount(kpiData.actualCompanyTotal),
        ],
      ];

      const sheets = {
        Dashboard: table1,
      };

      exportToExcel(fileName, sheets);
    }
  } 
}
